import { CashPickupBoxProps } from '@repo/types/cashPickupBoxProps.type';
import {
  IMG_CASH_PICKUP_GUIDE_01,
  IMG_CASH_PICKUP_GUIDE_03,
} from '@repo/assets';
import IMG_CASH_PICKUP_GUIDE from '@/assets/uploadFile/img_guide_cash_pickup.png';

export const CASH_PICKUP_STORE_INTRO_BOXES: CashPickupBoxProps[] = [
  {
    index: 1,
    title: <>Enter Personal Information</>,
    description:
      'Enter your personal information to pick up your refund in cash from Western Union.',
    image: IMG_CASH_PICKUP_GUIDE_01,
  },
  {
    index: 2,
    title: (
      <>
        Receiving Your Refund
        <br />
        at Western Union
      </>
    ),
    description:
      'After you enter your information and your departure is confirmed, we will send your refund within 21 days. You can then pick up the cash at Western Union.',
    image: IMG_CASH_PICKUP_GUIDE_03,
  },
];

export const CASH_PICKUP_STORE_INTRO_BOXES_FORCE: CashPickupBoxProps[] = [
  {
    index: 1,
    title: 'Enter Only Basic\nPersonal Information',
    description:
      'Enter your personal information to pick up your refund in cash from Western Union.',
    image: IMG_CASH_PICKUP_GUIDE_01,
  },
  {
    index: 2,
    title: 'Upload Proof of Immigration',
    description:
      'Please upload documents verifying your entry or departure.\n✈️ By Air: Upload flight ticket image\n🛳️ By Cruise: Upload itinerary & cruise ticket image',
    image: IMG_CASH_PICKUP_GUIDE,
  },
  {
    index: 3,
    title: 'Refund Remittance',
    description:
      'Refund will be sent within 21 business days after Customs check.',
    image: IMG_CASH_PICKUP_GUIDE_03,
  },
];

export const FORCE_TYPE_PROCEDURE_BOXES: CashPickupBoxProps[] = [
  {
    index: 1,
    title: 'Enter Payment Information',
    description: 'Enter your bank info within 3 months after the procedure.',
    image: IMG_CASH_PICKUP_GUIDE_01,
  },
  {
    index: 2,
    title: 'Upload Immigration Documents ',
    description:
      'Please upload documents that verify your entry or departure.\nIf departing by air: upload an image of your flight ticket.\nIf departing by cruise: upload your itinerary and cruise ticket.',
    image: IMG_CASH_PICKUP_GUIDE,
  },
  {
    index: 3,
    title: 'Refund Remittance',
    description:
      'Refund will be sent within 21 business days after Customs check.',
    image: IMG_CASH_PICKUP_GUIDE_03,
  },
];
